import React from 'react';
import { Form, Col, Row, Button } from 'react-bootstrap';
import axios, { AxiosRequestConfig } from 'axios';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import GuestSiteMenu from "../guest_menu";
import '../../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactGA from "react-ga4";

class FeedbackForm extends React.Component {
    constructor(props) {
        super(props);
        let userExists = !(props.location.state == null || props.location.state.user == null);
        this.state = {
            userExists: userExists,
            user: props.location.state.user,
            errors: {},
            input: {},
            previousPage: ''
        };

        /*this.createSelectItems = this.createSelectItems.bind(this);*/
        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        /*axios.get(`${Constants.apiURL}/api/Payment/accounts`, {
            params: {
                username: this.state.user.username
            }
        }).then(response => {
            if (response.data) {

                this.setState(() => ({
                    accounts: response.data
                }));
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });*/
    }

    handleFormChange(event) {
        let input = this.state.input;
        let errors = this.state.errors;
        input[event.target.name] = event.target.value;
        if (!!errors[event.target.name]) {
            errors[event.target.name] = null;
        }

        this.setState({
            input,
            errors
        });
    }

    validate() {
        let input = this.state.input;
        let errors = {};
        let isValid = true;

        if (!input["Feedback"]) {
            isValid = false;
            errors["Feedback"] = "Invalid.";
        }

        this.setState({
            errors: errors
        });

        return isValid;
    }

    handleSubmit(event) {

        event.preventDefault();
        if (!this.validate()) {
            alert('Please fill in required fields to proceed.');
            return;
        }
        this.setState({ loading: true });

        console.log(this.state);
        let formData = new FormData();
        for (var key in this.state.input) {
            formData.append(key, this.state.input[key]);
        }
        console.log(formData);
        for (var key in this.state.user) {
            formData.append(key, this.state.user[key]);
        }

        console.log(formData);

        axios.post(`${Constants.apiURL}/api/Request/feedback`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            console.log(response);
            if (response.data && response.data == true) {
                ReactGA.event({
                    category: 'Request',
                    action: 'Feedback',
                    label: 'Feedback Request'
                });
                alert('Thank you for your feedback! We look forward to improving your portal experience.');
                this.props.history.push({
                    pathname: '/orders',
                    state: {
                        user: this.state.user
                    }
                });
            }
            else {
                alert('Error processing your request');
            }
            this.setState({ loading: false });
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    render() {
        return (
            <div>
                {(this.state.userExists ? <SiteMenu user={this.state.user} currentPage='feedbackForm' /> : <GuestSiteMenu currentPage='feedbackForm' />)}
                <Form.Label style={{ margin: 3, marginLeft: 10, marginBottom:0 }} className="form-header">FEEDBACK FORM</Form.Label>
                <br />
                <Form.Label style={{ margin: 3, marginTop: -5, marginLeft: 10, fontSize: '15px', fontStyle:'italic' }}>
                    Confused about a feature or have an idea for a new one? Let us know how your portal experience could be improved!
                </Form.Label>
                <Form noValidate>
                    <Row>
                        <Col md={8}>
                            <Form.Group as={Row} className="mb-3" >
                                <Col md={12} style={{marginLeft:10}}>
                                    <Form.Control as="textarea" rows={5} name="Feedback" value={this.state.input.Feedback} onChange={this.handleFormChange}/>
                            </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                    <div hidden={this.state.userExists} style={{ marginLeft: 5 }}>
                        <Form.Label style={{ margin: 3, marginTop: -5, marginLeft: 5, fontSize: '15px', fontStyle: 'italic' }}>
                           (Optional) Please provide your contact information below if you would like to discuss this feedback with a member of our portal team.
                        </Form.Label>
                        <Row>
                            <Col md={4}>
                                <Form.Group as={Row} className="mb-3" >
                                    <Form.Label column md={3} >First name</Form.Label>
                                    <Col md={9}>
                                        <Form.Control type="input" name="firstName" value={this.state.input.firstName} onChange={this.handleFormChange}
                                            isInvalid={!!this.state.errors.firstName} />
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group as={Row} className="mb-3" >
                                    <Form.Label column md={3} >Last name</Form.Label>
                                    <Col md={9}>
                                        <Form.Control type="input" name="lastName" value={this.state.input.lastName} onChange={this.handleFormChange}
                                            isInvalid={!!this.state.errors.lastName} />
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <Form.Group as={Row} className="mb-3" >
                                    <Form.Label column md={3} >Email address</Form.Label>
                                    <Col md={9}>
                                        <Form.Control type="email" name="email" value={this.state.input.email} onChange={this.handleFormChange}
                                            isInvalid={!!this.state.errors.email} />
                                        <Form.Control.Feedback type='invalid'>
                                            {this.state.errors.email}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group as={Row} className="mb-3" >
                                    <Form.Label column md={3} >Phone number</Form.Label>
                                    <Col md={9}>
                                        <Form.Control type="phone" name="phone" value={this.state.input.phone} onChange={this.handleFormChange}
                                            isInvalid={!!this.state.errors.phone} />
                                        <Form.Control.Feedback type='invalid'>
                                            {this.state.errors.phone}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                </Form>
                <Button style={{ marginLeft: '10px', backgroundColor: '#1F419B' }} variant="primary" type="submit" onClick={this.handleSubmit}>
                    Submit
                </Button>
            </div>
        );
    }
}

export default FeedbackForm;